import { IExceptionQueryPrams } from '../../../../models/index';
import { clearExceptionListDetails, fetchAllExceptionListFail, fetchAllExceptionListStarted, fetchExceptionListSuccess } from '../../../reducer/exceptions/ListExceptionReducer';
import { getAllExceptionList } from '../../actionType/services/ServiceActionTypes';
import { ClearAllException, FetchALlExceptionListFailurePayload, FetchAllExceptionListFailure, FetchAllExceptionListRequest, FetchAllExceptionListStarted, FetchAllExceptionSuccess, FetchAllExceptionSuccessPayload } from '../../types/exceptions/FetchAllExceptionListTypes';

export const fetchAllExceptionListRequest = (pageNo: number, item: number, queryParams?: IExceptionQueryPrams, sort?: string): FetchAllExceptionListRequest => ({
  type: getAllExceptionList.FETCH_ALL_EXCEPTION_LIST_REQUEST,
  pageNo,
  item,
  queryParams,
  sort
});

/**
 * Fetch exception started saga action
 * @returns event started action
 */
export const getAllExceptionListStarted = (): FetchAllExceptionListStarted => ({
  type: fetchAllExceptionListStarted.type
});

/**
 * Fetch exception success saga action
 * @param payload :Event data
 * @returns success action
 */
export const getAllExceptionSuccess = (
  payload: FetchAllExceptionSuccessPayload
): FetchAllExceptionSuccess => ({
  type: fetchExceptionListSuccess.type,
  payload
});

/**
 * Fetch Exception Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const getAllExceptionListFailure = (
  payload: FetchALlExceptionListFailurePayload
): FetchAllExceptionListFailure => ({
  type: fetchAllExceptionListFail.type,
  payload
});

/**
 * Clear Exception saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearAllExceptions = (): ClearAllException => ({
  type: clearExceptionListDetails.type
});
